import type { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import type { IBaMatrixRowProps } from './IBaMatrixRowProps';

/** Колір клітинки з записами (прототип v4): синій rgba(31,78,188) з прозорістю 0.08 + a × 0.72; насичена (a > 0.6) — білий текст. */
const cellStyle = (alpha: number): CSSProperties => ({ background: `rgba(31, 78, 188, ${(0.08 + alpha * 0.72).toFixed(2)})`, color: alpha > 0.6 ? '#ffffff' : 'var(--ink)' });

/**
 * Рядок «Модулі × аналіз» (прототип v4 bdRows): назва модуля (600) і категорія (11px) — відкривають записи модуля; шість клітинок видів
 * (моноширинні, нуль — червона прогалина, підказка «Модуль · Вид: N — прогалина»); смуга виконаних вимог із відсотком («—» без вимог);
 * «N прогалин» червоним або «Покрито» зеленим.
 */
export function BaMatrixRow({ row, name, category, onOpen, onCell }: IBaMatrixRowProps) {
  const { t } = useTranslation();
  return (
    <div className="ba-grid ba-row">
      <button type="button" className="ba-row__name" onClick={onOpen}>
        <span className="ba-row__title">{name}</span>
        <span className="ba-row__cat">{category}</span>
      </button>
      {row.cells.map((cell) => {
        const tip = t('modBody.ba.cellTip', { name, label: t(`modBody.ba.cols.${cell.kind}`, { defaultValue: cell.kind }), count: cell.count })
          + (cell.count ? '' : t('modBody.ba.gapMark'));
        return (
          <button key={cell.kind} type="button" className={cx('ba-cell', !cell.count && 'is-gap')} style={cell.count ? cellStyle(cell.alpha) : undefined}
            title={tip} aria-label={tip} onClick={() => onCell(cell.kind)}>
            {String(cell.count)}
          </button>
        );
      })}
      <span className="ba-done">
        <span className="ba-done__bar"><span className="ba-done__fill" style={{ width: `${row.pct}%` }} /></span>
        <span className="ba-done__pct">{row.requirements ? `${row.pct}%` : '—'}</span>
      </span>
      <span className={cx('ba-gaps', !row.gaps && 'is-covered')}>{row.gaps ? t('modBody.ba.gapsN', { count: row.gaps }) : t('modBody.ba.covered')}</span>
    </div>
  );
}
